import { PgliteDatabase } from "drizzle-orm/pglite";
import { customers, InsertTransaction, invoices, Transaction, transactions } from "../schema";
import { eq, inArray } from "drizzle-orm";
import { DateTime } from "luxon";

class TransactionsRepository {
    public add = async (db: PgliteDatabase, data: InsertTransaction) => {
        const [res] = await db.insert(transactions).values(data).returning();
        return res;
    }
    public getAll = async (db: PgliteDatabase): Promise<Transaction[]> => {
        const data = await db.select()
            .from(transactions)
            .innerJoin(invoices, eq(invoices.invoiceNumber, transactions.invoiceNumber))
            .innerJoin(customers, eq(customers.id, invoices.customerId));

        return data.map(({ transactions: item, invoices: invoice, customers: customer }) => {
            return {
                ...item,
                date: DateTime.fromJSDate(item.date).toFormat('dd/MM/yyyy'),
                invoice,
                customer
            }
        });
    }
    public delete = async (db: PgliteDatabase, id: number) => {
        const res = await db.delete(transactions).where(eq(transactions.id, id)).execute();
        return res;
    }
    public deleteMany = async (db: PgliteDatabase, ids: number[]) => {
        const deleted = await db.delete(transactions).where(inArray(transactions.id, ids)).returning();
        return deleted;
    }
}

export const transactionsRepository = new TransactionsRepository();